module.exports = __webpack_public_path__ + "assets/76c868aae4af3be33d2624e1f0a53110.mp3";